

import React, { memo } from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';
import Icon from '../../Icon';
import LucideIcon from '../../LucideIcon';
import { Pencil } from 'lucide-react';
import Input from '../../Input';
import ContentLoader from '../../ContentLoader';
import BreadCrumbs from '../../BreadCrumbs';
import Text from '../../Text';
import '../styles/_title-box.scss';

/* eslint-disable react/no-unused-prop-types */
















function renderSubTitle(subtitle, subtitleLink, darkMode) {
  if (!subtitle) {return null;}

  const subtitleTextElement = <Text className="title-box__subtitle" placeholder noMargin darkTheme={darkMode}>{subtitle}</Text>;

  return subtitleLink ?

  <Link
    className={cx(
      'title-box__subtitle-link',
      { 'title-box__subtitle-link--dark-mode': darkMode }
    )}
    to={subtitleLink}>

        {subtitleTextElement}
      </Link> :

  subtitleTextElement;
}

function getTitle(
// eslint-disable-next-line react/prop-types
{ editableTitle, loading, darkMode, title, onBlurTitle, onChangeTitle, titlePlaceHolder })
{
  if (loading) {
    return (
      <ContentLoader className="title-box__title-loader" height={100} width={1000}>
        <rect x="0" y="0" rx={8} ry={8} width={1000} height={100} />
      </ContentLoader>);

  }

  return editableTitle ?

  <Input
    className="title-box__input"
    type="SECONDARY"
    defaultValue={title}
    onBlur={onBlurTitle}
    onChange={onChangeTitle}
    placeholder={titlePlaceHolder}
    id="title-box-input"
    prefix={<LucideIcon icon={Pencil} size={16} />}
    autoGrow /> :


  <Text heading3 noMargin ellipsisOverflow darkTheme={darkMode}>{title}</Text>;
}

function TitleBox(props) {
  const {
    title,
    titlePrefixContent,
    breadCrumbs,
    subtitle,
    subtitleLink,
    darkMode,
    titleSuffixIcon,
    titleSuffix
  } = props;

  if (subtitle && breadCrumbs) {
    /* eslint-disable no-console */
    console.warn('Both Breadcrumbs and a subtitle passed as props to TitleBox. Ignoring subtitle.');
  }

  return (
    <div className="title-box">
      {
      breadCrumbs ?
      <BreadCrumbs items={breadCrumbs} darkMode={darkMode} /> :
      renderSubTitle(subtitle, subtitleLink, darkMode)}

      <div className="title-box__container">
        <div className="title-box__suffix-icon-wrapper">
          {titlePrefixContent && titlePrefixContent}
          {getTitle(props)}
          {
          titleSuffixIcon && title &&
          <Icon
            name={titleSuffixIcon}
            className="title-box__suffix-icon"
            size={20}
            color={darkMode ? 'white' : 'black'} />}



          {titleSuffix && title ?
          <div className="title-box__suffix">{titleSuffix}</div> :
          null}

        </div>
      </div>
    </div>);

}

TitleBox.displayName = 'TitleBox';

TitleBox.defaultProps = {
  editableTitle: false,
  darkMode: false
};

export default memo(TitleBox);